import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { SecurityRole } from '../constants'
import type { User } from '../types'

/** Tolerates a missing AuthProvider (pages rendered alone in tests): no user, not an admin. */
export function useCurrentUser(): User | null {
  return useContext(AuthContext)?.user ?? null
}

export function useIsTeamAdmin(): boolean {
  return (useCurrentUser()?.securityRole ?? 0) >= SecurityRole.TEAM_ADMIN
}
